import React, { useContext } from "react";
import { Box } from "@mui/material";
import { VideoCallContext } from "../context/VideoCallContext";

interface VideoCallContainerProps {
  containerId: string;
  containerType: "main" | "pip";
  style?: React.CSSProperties;
}

const VideoCallContainer: React.FC<VideoCallContainerProps> = ({
  containerId,
  containerType,
  style = {},
}) => {
  const { videoCallState } = useContext(VideoCallContext);

  const isActive =
    videoCallState.renderLocation === containerType &&
    videoCallState.shouldRenderLiveKit;

  return (
    <Box
      id={containerId}
      sx={{
        width: "100%",
        height: "100%",
        position: "relative",
        backgroundColor: isActive ? "transparent" : "#f5f5f5",
        borderRadius: "8px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        ...style,
      }}
    >
      {/* The PersistentVideoRoom will position itself over this container when active */}
    </Box>
  );
};

export default VideoCallContainer;
